import WidgetFooter from './WidgetFooter';
export default WidgetFooter;



// WEBPACK FOOTER //
// ./src/components/WidgetFooter/index.js